import { render, staticRenderFns } from "./ConfiguratorDetail.vue?vue&type=template&id=2dddd17e&"
import script from "./ConfiguratorDetail.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports